var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.00082C7.48 2.00037 2.99963 6.48 2.99918 12C2.99873 17.52 7.47836 22.0004 12.9984 22.0008C18.5184 22.0013 22.9987 17.5216 22.9992 12.0016C22.9996 6.48164 18.52 2.00127 13 2.00082ZM4.99918 12.0002C4.99954 7.58016 8.57984 4.00046 12.9998 4.00082C14.8498 4.00097 16.5498 4.63111 17.8997 5.69122L6.68878 16.9003C5.62889 15.5502 4.99903 13.8502 4.99918 12.0002ZM8.09866 18.3104C9.44858 19.3705 11.1485 20.0007 12.9985 20.0008C17.4185 20.0012 20.9988 16.4215 20.9992 12.0015C20.9993 10.1515 20.3695 8.45142 19.3096 7.10134L8.09866 18.3104Z",
    fill: "#EB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock24Px);
export default __webpack_public_path__ + "static/media/block_24px.9cfd939c8af635cf1a9a52dd675f42bd.svg";
export { ForwardRef as ReactComponent };